export const GET_QUESTIONS = {
  INITIATE: 'GET_QUESTIONS_INITIATE',
  SUCCESS: 'GET_QUESTIONS_SUCCESS',
  FAILED: 'GET_QUESTIONS_FAILED',
};

export const getAllQuestionsInitiate = payload => ({
  type: GET_QUESTIONS.INITIATE,
  payload,
});

export const getAllQuestionsFailed = err => ({
  type: GET_QUESTIONS.FAILED,
  err,
});

export const getAllQuestionsSuccess = questionsData => ({
  type: GET_QUESTIONS.SUCCESS,
  questionsData,
});
